import { render, staticRenderFns } from "./PrismicLink.vue?vue&type=template&id=31328bb7&"
import script from "./PrismicLink.vue?vue&type=script&lang=js&"
export * from "./PrismicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports